import { DateTimeRangePicker } from '@global-engineering-shared/gweb-material-global';
import { rest } from 'lodash';

import useStyles from 'components/DateTimePicker/components/CustomDateTimeRangePicker/CustomDateTimeRangePicker.styles';
import { handleOnDateTimeRangeAccept } from 'components/DateTimePicker/components/CustomDateTimeRangePicker/utils/handleOnDateTimeRangeAccept';
import { useDates } from 'context/DateProvider/DateProvider';
import { convertNowToISO } from 'context/DateProvider/utils/convertNowToISO';

const CustomDateTimeRangePicker = () => {
  const classes = useStyles();
  const { dates, setDates } = useDates();

  const getDateValue = () => [
    new Date(convertNowToISO(dates.from)),
    new Date(convertNowToISO(dates.to)),
  ];

  return (
    <div className={classes.root}>
      <DateTimeRangePicker
        key={`${dates.from}-${dates.to}`}
        {...rest}
        value={getDateValue()}
        placeholder="dd/mm/yyyy hh:mm - dd/mm/yyyy hh:mm"
        onDateTimeRangeAccept={handleOnDateTimeRangeAccept(dates, setDates)}
      />
    </div>
  );
};

export default CustomDateTimeRangePicker;
